import { createContext, type ReactNode, useState } from 'react';

interface Props {
    children: ReactNode;
}

export enum BaseModalType {
    Accept = 'Accept',
    AndroidConfig = 'AndroidConfig',
    Config = 'Config',
    Confirmation = 'Confirmation',
    Create = 'Create',
    Default = 'Default',
    Duplicate = 'Duplicate',
    Edit = 'Edit',
    Iframe = 'Iframe',
    iOSConfig = 'iOSConfig',
}

type ModelState = {
    [key in BaseModalType | string]?: { show: boolean; openAsDrawer?: boolean };
};

interface State {
    state: ModelState;
    openModal?: (key: BaseModalType | string, openAsDrawer?: boolean) => void;
    closeModal?: (key: BaseModalType | string) => void;
}

const ProviderState: ModelState = Object.values(BaseModalType).reduce(
    (state: ModelState, value: BaseModalType) => {
        state[value] = { show: false, openAsDrawer: false };
        return state;
    },
    {},
);

export const BaseModalContext = createContext<State>({ state: ProviderState });

export const BaseModalProvider = ({ children }: Props) => {
    const [state, setState] = useState<ModelState>(ProviderState);

    const openModal = (contextKey: BaseModalType | string, openAsDrawer?: boolean) =>
        setState((currentState) => ({ ...currentState, [contextKey]: { show: true, openAsDrawer } }));

    const closeModal = (contextKey: BaseModalType | string) =>
        setState((currentState) => ({ ...currentState, [contextKey]: { show: false, openAsDrawer: false } }));

    return (
        <BaseModalContext.Provider value={{ state, openModal, closeModal }}>
            {children}
        </BaseModalContext.Provider>
    );
};
